/* global PLATFORM, G */
import { curry, isArr, setKey } from 'lib/util'

/**
 * Persists incoming value in corresponding component's state.
 *
 * Incoming value will be converted into Array
 *
 * Since there is no need to refresh the ui, it is handled on component level only.
 *
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Gaia.PlatformEvent} event - event
 * @returns {Gaia.PlatformEvent} event
 */
const persistOptions = (module, component, event) => {
  const state = component[G.STATE]
  const { item, options } = event.detail
  const shouldSetUndo = options?.length !== 1 || item?.key !== options[0].key

  state.value = item ? (isArr(item) && item) || [item] : []

  // The internals of the Autocomplete differ in behaviour from mobile to web.
  // On mobile, the `onChange` handler will be executed on mount with the previous value
  // as `item`. This causes this handler to be executed in edit forms even nothing changed
  // Therefore, we check here if either are on web, or, if on mobile, if we actually selected
  // something or if it's the default value, and only set the flag accordingly
  if (PLATFORM !== 'mobile' || shouldSetUndo) {
    setKey(true, G.UNDO, module[G.STATE][G.ACTION][G.STATE])
  }

  return event
}

export default curry(persistOptions)
